// Return true if the webview query param exists on the URL
export const getIsWebView = () => {
  const webview =
    new URLSearchParams(document.location.search).has("webview") ||
    document.getElementById("webview")
      ? true
      : false;
  return webview;
};
